import { BACK_ICON_PATH, T_LOGO_ICON_PATH, TOKEN_SYMBOL_ICON_PATH } from '@/consts/imgPath';
import * as ViewModel from '@/core/presenter/viewModel/viewTypes';

interface IProps {
  viewType: ViewModel.HomeViewType;
  onClickBackBtn: () => void;
}

const HomeHeader = ({ viewType, onClickBackBtn }: IProps) => {
  // const [logoHeight, setLogoHeight] = useState<number>(62);

  // useEffect(() => {
  //   const updateLogoSize = () => {
  //     const width = window.innerWidth;

  //     // 화면 크기에 따라 로고 높이 조정
  //     if (width <= 350) {
  //       // 매우 작은 모바일 (305-350px)
  //       setLogoHeight(32);
  //     } else if (width <= 375) {
  //       // 작은 모바일 (iPhone SE 등)
  //       setLogoHeight(40);
  //     } else if (width <= 414) {
  //       // 일반 모바일
  //       setLogoHeight(48);
  //     } else if (width <= 768) {
  //       // 태블릿
  //       setLogoHeight(56);
  //     } else {
  //       // 데스크톱
  //       setLogoHeight(62);
  //     }
  //   };

  //   updateLogoSize();
  //   window.addEventListener('resize', updateLogoSize);

  //   return () => {
  //     window.removeEventListener('resize', updateLogoSize);
  //   };
  // }, []);

  const getTitle = () => {
    if (viewType === ViewModel.HomeViewType.SEND) return '보내기';
    if (viewType === ViewModel.HomeViewType.RECEIVE) return '받기';
    if (viewType === ViewModel.HomeViewType.SEND_CHECK) return '보내기 확인';

    return 'GDFINANCE';
  };

  return (
    <header className="main-header detail-header" id="header">
      {/* <header className="main-header detail-header" id="header"> */}
      {viewType !== ViewModel.HomeViewType.MAIN ? (
        <button type="button" className="back-btn" onClick={onClickBackBtn}>
          <img src={BACK_ICON_PATH} alt="뒤로가기" className="back-icon" />
        </button>
      ) : <button type="button" className="back-btn" />}

      {viewType === ViewModel.HomeViewType.MAIN ||
        viewType === ViewModel.HomeViewType.SOL ||
        viewType === ViewModel.HomeViewType.TOKEN ? (
        <>
          <img src={T_LOGO_ICON_PATH} alt="GDF" className="main-logo" />
          <div />
        </>
      ) : (
        <>
          <div className="sub-title-container">
            <img src={TOKEN_SYMBOL_ICON_PATH} alt="GDF 로고" className="main-logo" />
            <span className="sub-title-text heading-4 font-bold">{getTitle()}</span>

          </div>
          <div></div>
        </>
        // <div className="inner" style={{ cursor: 'default' }}>
        //   <div className="img">
        //     <img src={TOKEN_SYMBOL_ICON_PATH} alt="SOL" />
        //   </div>
        //   <h2>{getTitle()}</h2>
        // </div>
      )}
    </header>
  );
};

export default HomeHeader;
